module.exports = __webpack_public_path__ + "img/open_envelope.669f675c.svg";